import { Chip } from '@mui/material'
import React from 'react'

// Phase 1 loose end (completed post-audit): status rendered as a colored
// chip on every collection list so editors can see draft/offline state at a
// glance. Colors map to the lifecycle: live = green, hidden = red,
// in-progress = grey, queued = orange.
const COLORS = {
  online: 'success',
  offline: 'error',
  draft: 'default',
  scheduled: 'warning',
}

const Status = (path) =>
  function (rowData) {
    return rowData[path] ? (
      <Chip
        label={rowData[path]}
        color={COLORS[rowData[path]] || 'default'}
        size="small"
      />
    ) : (
      ''
    )
  }
export default Status
